var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRelinkName = function SvgRelinkName(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#relink-name_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M41 29V0H29v29H0v12h29v29h12V41h29V29H41Zm0 0H29v12h12V29Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "relink-name_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgRelinkName;